import React from 'react';
import { PnlContractsInfoButton } from './PnlScalingInfoModal';
import './InputForm.css';

/** Sample preview for Single/Account Blowout Risk tab when beta-ended message is shown */
function SingleTabSamplePreview({ riskMode, hideResultsPlaceholder = false }) {
  return (
    <div className={`input-form-container${hideResultsPlaceholder ? ' input-form-container--pro-lock' : ''}`} style={{ opacity: 0.9 }}>
      {riskMode === 'apexMae' && (
        <div className="apex-rule-link-container">
          <button type="button" className="learn-apex-rule-btn" disabled>
            Learn About Consistency Rules
          </button>
        </div>
      )}
      <div className={`input-form ${riskMode === 'apexMae' ? 'input-form-apex-mae' : ''}`}>
        <div className="form-section">
          <h2 className="form-title">Strategy Risk Assessment</h2>
          <p className="form-description">
            Select a strategy and configure your trading parameters to assess risk
          </p>
        </div>
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">Strategy <span className="required">*</span></label>
            <div className="select-wrapper">
              <select className="form-input form-select" disabled value="">
                <option>No strategies found</option>
              </select>
            </div>
            <small className="form-hint">Select the strategy you want to analyze</small>
          </div>
          {riskMode === 'apexMae' && (
            <div className="form-group">
              <label className="form-label">Consistency Rule <span className="required">*</span></label>
              <select className="form-input form-select" disabled value="50">
                <option>50%</option>
              </select>
              <small className="form-hint">
                Select the consistency rule percentage used for consistency-limit and payout-path calculations.
              </small>
            </div>
          )}
          <div className="form-group">
            <label className="form-label">Contract Type <span className="required">*</span></label>
            <div className="input-form-contract-type-chips">
              <button type="button" className="input-form-contract-type-chip" disabled>
                <span className="input-form-contract-type-label">NQ</span>
                <span className="input-form-contract-type-sublabel">(Full-size)</span>
              </button>
              <button type="button" className="input-form-contract-type-chip active" disabled>
                <span className="input-form-contract-type-label">MNQ</span>
                <span className="input-form-contract-type-sublabel">(Micro - 1/10th value)</span>
              </button>
            </div>
            <small className="form-hint">
              Select NQ if sheet data is for full-size contracts, or MNQ if it&apos;s for micro contracts
            </small>
          </div>
          <div className="form-group">
            <label className="form-label">Account Size <span className="required">*</span></label>
            <div className="input-form-account-size-chips-stacked">
              <div className="input-form-account-size-chips">
                {['$25K', '$50K', '$100K'].map((size) => (
                  <button key={size} type="button" className={`input-form-account-size-chip ${size === '$50K' ? 'active' : ''}`} disabled>
                    {size}
                  </button>
                ))}
              </div>
              <div className="input-form-account-size-chips">
                {['$150K', '$250K', '$300K'].map((size) => (
                  <button key={size} type="button" className={`input-form-account-size-chip ${size === '$150K' && riskMode === 'apexMae' ? 'active' : ''}`} disabled>
                    {size}
                  </button>
                ))}
              </div>
            </div>
            <small className="form-hint">
              {riskMode === 'apexMae'
                ? 'Select your Apex Trader Funding account size.'
                : 'Select your original account size (starting capital). Risk percentages are calculated relative to this amount.'}
            </small>
          </div>
          <div className="form-group">
            <div className="input-form-label-with-info-row">
              <label className="form-label">
                Default Contract Size Multiplier <span className="required">*</span>
              </label>
              <PnlContractsInfoButton iconSize={16} />
            </div>
            <input type="text" className="form-input" value={riskMode === 'apexMae' ? '4' : '1'} readOnly disabled />
          </div>
          {riskMode === 'risk' && (
            <div className="form-group">
              <label className="form-label">Max Trailing Drawdown ($) <span className="required">*</span></label>
              <input type="text" className="form-input" value="1000" readOnly disabled />
              <small className="form-hint">
                Your account&apos;s maximum trailing drawdown limit (from NinjaTrader/Apex)
              </small>
            </div>
          )}
          {riskMode === 'apexMae' && (
            <div className="form-group">
              <label className="form-label">Acct. Balance ($) <span className="required">*</span></label>
              <input type="text" className="form-input" value="52500" readOnly disabled />
              <small className="form-hint">
                Your current account balance (e.g., if you started with $50k and now have $52,500, enter 52500)
              </small>
            </div>
          )}
        </div>
        <button type="button" className="input-form-submit" disabled>
          Analyze Risk
        </button>
      </div>
      {!hideResultsPlaceholder && (
      <div className="no-results-message" style={{ marginTop: '2rem' }}>
        <div className="no-results-content">
          <p className="no-results-text">
            {riskMode === 'risk' ? 'Analyze your strategy to see risk assessment results.' : 'Analyze your strategy to see % Rule results.'}
          </p>
        </div>
      </div>
      )}
    </div>
  );
}

export default SingleTabSamplePreview;
